import React from "react";
import { PackageCheck, PackageMinus, PackageX, Ship } from "lucide-react";
import { useStock } from "@/hooks/useStock";

const STYLES = {
  unconfirmed: { label: "Stock confirmation required", cls: "bg-amber-50 text-amber-800 border-amber-200", Icon: PackageMinus },
  in: { label: "In stock", cls: "bg-emerald-50 text-emerald-800 border-emerald-200", Icon: PackageCheck },
  low: { label: "Only a few left", cls: "bg-amber-50 text-amber-800 border-amber-200", Icon: PackageMinus },
  order: { label: "On order", cls: "bg-sky-50 text-sky-800 border-sky-200", Icon: Ship },
  out: { label: "Sold out", cls: "bg-red-50 text-red-700 border-red-200", Icon: PackageX },
};

export const StockBadge = ({ slug, testId, className = "" }) => {
  const stock = useStock();
  const s = stock[slug];
  if (!s?.status || !STYLES[s.status]) return null;
  const { label, cls, Icon } = STYLES[s.status];
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full border ${cls} ${className}`} data-testid={testId}>
      <Icon className="w-3 h-3" /> {label}
    </span>
  );
};
